export default "__VITE_ASSET__93e89a1f__"